document.addEventListener('DOMContentLoaded', function () {
  var sidebar = document.getElementById('catalogSidebar');
  if (!sidebar) return;

  var items = sidebar.querySelectorAll('.catalog-sidebar__item.has-children');
  items.forEach(function (item) {
    var link = item.querySelector('.catalog-sidebar__link');
    link.addEventListener('click', function (e) {
      if (window.innerWidth < 990) {
        e.preventDefault();
        item.classList.toggle('is-open');
      }
    });
  });

  var moreButtons = sidebar.querySelectorAll('.catalog-sidebar__more');
  moreButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-target');
      var list = document.getElementById(targetId);
      if (!list) return;
      list.classList.toggle('is-expanded');
      var label = btn.querySelector('span');
      if (list.classList.contains('is-expanded')) {
        label.textContent = 'ნაკლების ნახვა';
      } else {
        label.textContent = 'იხილეთ მეტი';
      }
    });
  });
});